import { useEffect, type ReactNode } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'
import { PublicChatWidget } from '../components/PublicChatWidget'
import { useScrollReveal } from '../hooks/useScrollReveal'
import type { Customer, HotelProfile } from '../api/types'

export function Layout({
  hotel,
  customer,
  onLogout,
  children,
}: {
  hotel?: HotelProfile
  customer: Customer | null
  onLogout: () => void
  children: ReactNode
}) {
  useScrollReveal()

  useEffect(() => {
    if (hotel?.meta_title) document.title = hotel.meta_title
    else if (hotel?.hotel_name) document.title = hotel.hotel_name

    if (hotel?.primary_color) {
      document.documentElement.style.setProperty('--accent', hotel.primary_color)
    }
    if (hotel?.secondary_color) {
      document.documentElement.style.setProperty('--deep', hotel.secondary_color)
    }
  }, [hotel])

  return (
    <div className="public-shell">
      <Header hotel={hotel} customer={customer} onLogout={onLogout} />
      {children}
      <Footer hotel={hotel} />
      <PublicChatWidget customer={customer} />
    </div>
  )
}
